<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter401cultivationtechniques">CHAPTER 401 - CULTIVATION TECHNIQUES</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter402indestructibleyinandyangmeridian">CHAPTER 402 - INDESTRUCTIBLE YIN AND YANG MERIDIAN</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter403peoplefromthelongquansect">CHAPTER 403 - PEOPLE FROM THE LONGQUAN SECT</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter404infrontoftheclearmoonpavilion">CHAPTER 404 - IN FRONT OF THE CLEAR MOON PAVILION</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter405cabinandthesoundofthezither">CHAPTER 405 - CABIN AND THE SOUND OF THE ZITHER</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter406retreat">CHAPTER 406 - RETREAT</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter407mustdie">CHAPTER 407 - MUST DIE?</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter408leavingthemartialhouse">CHAPTER 408 - LEAVING THE MARTIAL HOUSE</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter409torture" title="Link target outside of Sample">CHAPTER 409 - TORTURE</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter410whentherearedifficulties" title="Link target outside of Sample">CHAPTER 410 - WHEN THERE ARE DIFFICULTIES</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter411halfkingpossession" title="Link target outside of Sample">CHAPTER 411 - HALF KING POSSESSION</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter412treason" title="Link target outside of Sample">CHAPTER 412 - TREASON</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter413beheadinggrandmaster" title="Link target outside of Sample">CHAPTER 413 - BEHEADING GRANDMASTER</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter414fearofallraces" title="Link target outside of Sample">CHAPTER 414 - FEAR OF ALL RACES</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter415threat" title="Link target outside of Sample">CHAPTER 415 - THREAT</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter416sectmasterlongquan" title="Link target outside of Sample">CHAPTER 416 - SECT MASTER LONG QUAN</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter417curtainfall" title="Link target outside of Sample">CHAPTER 417 - CURTAINFALL</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter418backtobouldercity" title="Link target outside of Sample">CHAPTER 418 - BACK TO BOULDER CITY</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter419linyurouleft" title="Link target outside of Sample">CHAPTER 419 - LIN YUROU LEFT</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter420departureendofthisvolume" title="Link target outside of Sample">CHAPTER 420 - DEPARTURE END OF THIS VOLUME</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter421donotforget" title="Link target outside of Sample">CHAPTER 421 - DO NOT FORGET</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter422chinesebandit" title="Link target outside of Sample">CHAPTER 422 - CHINESE BANDIT</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter423symboldaoheavenlyalliance" title="Link target outside of Sample">CHAPTER 423 - SYMBOL DAO HEAVENLY ALLIANCE</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter424mine" title="Link target outside of Sample">CHAPTER 424 - MINE</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter425tenthousandpoundsandapound" title="Link target outside of Sample">CHAPTER 425 - TEN THOUSAND POUNDS AND A POUND</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter426souldevouringbloodsymbol" title="Link target outside of Sample">CHAPTER 426 - SOUL DEVOURING BLOOD SYMBOL</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter427instantsymbol" title="Link target outside of Sample">CHAPTER 427 - INSTANT SYMBOL</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter428talismanshop" title="Link target outside of Sample">CHAPTER 428 - TALISMAN SHOP</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter429oldmeng" title="Link target outside of Sample">CHAPTER 429 - OLD MENG</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter430guestsfromtalismanshop" title="Link target outside of Sample">CHAPTER 430 - GUESTS FROM TALISMAN SHOP</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter431mysteriousmaster" title="Link target outside of Sample">CHAPTER 431 - MYSTERIOUS MASTER</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter432replies" title="Link target outside of Sample">CHAPTER 432 - REPLIES</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter433qijijiangjia" title="Link target outside of Sample">CHAPTER 433 - QI JI JIANG JIA</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter434youngmaster" title="Link target outside of Sample">CHAPTER 434 - YOUNG MASTER</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter435mrmo" title="Link target outside of Sample">CHAPTER 435 - MR MO</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter436longquansectisnothing" title="Link target outside of Sample">CHAPTER 436 - LONGQUAN SECT IS NOTHING</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter437soulrefiningtalisman" title="Link target outside of Sample">CHAPTER 437 - SOUL REFINING TALISMAN</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter438ancestorofjiang" title="Link target outside of Sample">CHAPTER 438 - ANCESTOR OF JIANG</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter439thirdstar" title="Link target outside of Sample">CHAPTER 439 - THIRD STAR</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter440astheniaseekinginstruction" title="Link target outside of Sample">CHAPTER 440 - ASTHENIA SEEKING INSTRUCTION</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter441identityguessing" title="Link target outside of Sample">CHAPTER 441 - IDENTITY GUESSING</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter442ladyinblack" title="Link target outside of Sample">CHAPTER 442 - LADY IN BLACK</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter443back" title="Link target outside of Sample">CHAPTER 443 - BACK</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter444shopdown" title="Link target outside of Sample">CHAPTER 444 - SHOP DOWN</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter445decisionofthejiangfamily" title="Link target outside of Sample">CHAPTER 445 - DECISION OF THE JIANG FAMILY</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter446condemnationagainsttheunionofsymboldao" title="Link target outside of Sample">CHAPTER 446 - CONDEMNATION AGAINST THE UNION OF SYMBOL DAO</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter447confession" title="Link target outside of Sample">CHAPTER 447 - CONFESSION</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter448arriveatthedoortoapologize" title="Link target outside of Sample">CHAPTER 448 - ARRIVE AT THE DOOR TO APOLOGIZE</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter449talkingconditions" title="Link target outside of Sample">CHAPTER 449 - TALKING CONDITIONS</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter450enteringthetalismandaoalliance" title="Link target outside of Sample">CHAPTER 450 - ENTERING THE TALISMAN DAO ALLIANCE</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter451longquandivision" title="Link target outside of Sample">CHAPTER 451 - LONGQUAN DIVISION</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter452tokencriteria" title="Link target outside of Sample">CHAPTER 452 - TOKEN CRITERIA</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter453birth" title="Link target outside of Sample">CHAPTER 453 - BIRTH</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter454farewellsectmasterlongquan" title="Link target outside of Sample">CHAPTER 454 - FAREWELL SECT MASTER LONGQUAN</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter455juniorsisterleng" title="Link target outside of Sample">CHAPTER 455 - JUNIOR SISTER LENG</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter456hematitefruit" title="Link target outside of Sample">CHAPTER 456 - HEMATITE FRUIT</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter457herbaamaryllii" title="Link target outside of Sample">CHAPTER 457 - HERBA AMARYLLII</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter458fruitpicking" title="Link target outside of Sample">CHAPTER 458 - FRUIT PICKING</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter459hecaughtupwithme" title="Link target outside of Sample">CHAPTER 459 - HE CAUGHT UP WITH ME</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter460itwashim" title="Link target outside of Sample">CHAPTER 460 - IT WAS HIM!</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter461unforgettablestrength" title="Link target outside of Sample">CHAPTER 461 - UNFORGETTABLE STRENGTH</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter462calculation" title="Link target outside of Sample">CHAPTER 462 - CALCULATION?</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter463nixuexin" title="Link target outside of Sample">CHAPTER 463 - NI XUE XIN</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter464appreciation" title="Link target outside of Sample">CHAPTER 464 - APPRECIATION</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter465suprema" title="Link target outside of Sample">CHAPTER 465 - SUPREMA</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter466ninecoloredbluelotus" title="Link target outside of Sample">CHAPTER 466 - NINE-COLORED BLUE LOTUS</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter467valiantbody" title="Link target outside of Sample">CHAPTER 467 - VALIANT BODY</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter468blackandwhitepisces" title="Link target outside of Sample">CHAPTER 468 - BLACK AND WHITE PISCES</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter469longquansecttrial" title="Link target outside of Sample">CHAPTER 469 - LONGQUAN SECT TRIAL</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter470fingerprintsofthegods" title="Link target outside of Sample">CHAPTER 470 - FINGERPRINTS OF THE GODS</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter471dragonflamecurse" title="Link target outside of Sample">CHAPTER 471 - DRAGON FLAME CURSE</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter472truedragonpower" title="Link target outside of Sample">CHAPTER 472 - TRUE DRAGON POWER</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter473welcomeall" title="Link target outside of Sample">CHAPTER 473 - WELCOME ALL</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter474howtoend" title="Link target outside of Sample">CHAPTER 474 - HOW TO END?</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter475returntotheheavenlycourt" title="Link target outside of Sample">CHAPTER 475 - RETURN TO THE HEAVENLY COURT</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter476heavenlyabyssandancientrace" title="Link target outside of Sample">CHAPTER 476 - HEAVENLY ABYSS AND ANCIENT RACE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter477invitationfromallraces" title="Link target outside of Sample">CHAPTER 477 - INVITATION FROM ALL RACES</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter478bloodspiritgold" title="Link target outside of Sample">CHAPTER 478 - BLOOD SPIRIT GOLD</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter479provocation" title="Link target outside of Sample">CHAPTER 479 - PROVOCATION</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter480suppressing" title="Link target outside of Sample">CHAPTER 480 - SUPPRESSING</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter481breakthroughagain" title="Link target outside of Sample">CHAPTER 481 - BREAKTHROUGH AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter482dragonsnakesociety" title="Link target outside of Sample">CHAPTER 482 - DRAGON SNAKE SOCIETY</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter483seat" title="Link target outside of Sample">CHAPTER 483 - SEAT</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter484unqualified" title="Link target outside of Sample">CHAPTER 484 - UNQUALIFIED</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter485handoverthequota" title="Link target outside of Sample">CHAPTER 485 - HAND OVER THE QUOTA?</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter486xueyang" title="Link target outside of Sample">CHAPTER 486 - XUE YANG</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter487theappearanceofthecraneyiming" title="Link target outside of Sample">CHAPTER 487 - THE APPEARANCE OF THE CRANE YIMING</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter488ancientdivinephoenixtechnique" title="Link target outside of Sample">CHAPTER 488 - ANCIENT DIVINE PHOENIX TECHNIQUE</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter489earlyfogpowder" title="Link target outside of Sample">CHAPTER 489 - EARLY FOG POWDER</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter490unfilialson" title="Link target outside of Sample">CHAPTER 490 - UNFILIAL SON</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter491kingsfirstappearance" title="Link target outside of Sample">CHAPTER 491 - KING'S FIRST APPEARANCE</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter492stoneflameking" title="Link target outside of Sample">CHAPTER 492 - STONE FLAME KING</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter493xiaozhan" title="Link target outside of Sample">CHAPTER 493 - XIAO ZHAN</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter494sixkillingcurses" title="Link target outside of Sample">CHAPTER 494 - SIX KILLING CURSES</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter495burningsky" title="Link target outside of Sample">CHAPTER 495 - BURNING SKY</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter496oppression" title="Link target outside of Sample">CHAPTER 496 - OPPRESSION</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter497federation" title="Link target outside of Sample">CHAPTER 497 - FEDERATION</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter498brothermo" title="Link target outside of Sample">CHAPTER 498 - BROTHER MO</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter499wound" title="Link target outside of Sample">CHAPTER 499 - WOUND</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter500spiritearth" title="Link target outside of Sample">CHAPTER 500 - SPIRIT EARTH</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?bcc72524